export default {
      id: "non_user_coupon-usage",
      viewBox: "0 0 150 150",
      url: "/" + "images/icons.3.109.2.svg#non_user_coupon-usage",
      toString: function () {
        return this.url;
      }
    }